import React from "react";

export default function Footer() {
  return (
    <footer className="d-footer">
      <div className="row align-items-center justify-content-between">
        <div className="col-auto">
          <p className="mb-0">&copy; 2024 Way2Umrah. All Rights Reserved.</p>
        </div>
        <div className="col-auto">
          <p className="mb-0">Powered by Way 2 Websoft Technologies Pvt Ltd</p>
        </div>
      </div>
    </footer>
  );
}
